/**
 * Created by shamim.ahsan on 10/24/2018.
 */
import {Routes} from '@angular/router';
import {TreatyBepsCbcExchangeStatusComponent} from './components/treaty-beps-cbc-exchange-status/treaty-beps-cbc-exchange-status.component';
import {WithholdingTaxRatesComponent} from "./components/withholding-tax-rates/withholding-tax-rates.component";
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';

export const TreatyRoutes: Routes = [
  {
    path: 'treaties',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'treaties/:documentId',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'treaties/:countryOne/:countryTwo',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'treaties/:countryOne/:countryTwo/:documentId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'beps-cbc-exchange-status',
    component: TreatyBepsCbcExchangeStatusComponent
  },
  {
    path: 'treaty-withholding-tax-rates',
    component: WithholdingTaxRatesComponent
  }
];
